module.exports = __webpack_public_path__ + "img/ruleta.1d2f65db.png";